import * as React from 'react'
import { isNil, map, some } from 'lodash'
import styled from 'styled-components'

import { UnsupportedValueError } from '~/errors'
import type { IProductFilter, IProductFilterRangeType } from '~/types/product-filters'

import { FilterItemLayout } from '../filter-item/filter-item-layout'
import { FilterItemLists } from '../filter-item/filter-item-lists'
import { FilterItemPriceRanges } from '../filter-item/filter-item-price-ranges'

export interface ContentProps {
  productFilters: IProductFilter[]
}

const Container = styled.div`
  background: ${props => props.theme.colors.white};
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;
`

export function Content(props: ContentProps) {
  const { productFilters } = props

  return (
    <Container>
      {productFilters.map(productFilter => {
        switch (productFilter.type) {
          case 'list': {
            const hasSelectedValues = some(productFilter.values, 'selected')

            return (
              <FilterItemLayout title={productFilter.label} key={productFilter.key} defaultIsOpen={hasSelectedValues}>
                <FilterItemLists productFilter={productFilter} />
              </FilterItemLayout>
            )
          }

          case 'range': {
            const hasValues = some(productFilter.values, (item: IProductFilterRangeType) => !isNil(item.value))

            /**
             * We need to re-mount when the values were changed and
             * re-initialize the state of the FilterItemPriceRanges
             * component.
             */
            const key = map(productFilter.values, 'value').join(',')

            return (
              <FilterItemLayout title={productFilter.label} key={productFilter.key} defaultIsOpen={hasValues}>
                <FilterItemPriceRanges key={key} productFilter={productFilter} />
              </FilterItemLayout>
            )
          }

          default: {
            console.error(new UnsupportedValueError(productFilter.type))

            return null
          }
        }
      })}
    </Container>
  )
}
